<pl-gauge-chart
  *ngIf="block && block.data && block.data.gauge"
  [color]="block.data.gauge.colour"
  [max]="max()"
  [min]="min()"
  [suffixLabel]="block.data.gauge.suffix_label"
  [title]="block.data.title"
  [value]="value()"
/>
